import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MunicipalitiesService } from '../../services/http/municipalities/municipalities.service';
import { MunicipalityManagement } from '../../services/http/municipalities/municipalities.interface';

@Component({
  selector: 'app-information-card',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './information-card.component.html',
  styleUrl: './information-card.component.scss'
})
export class InformationCardComponent {
  @Input() styleClass = 'primary';
  @Input() title = '';
  @Input() description = '';
  @Input() showEdit = true;
  @Input() showPoblation = false;
  @Input() urlAction = '';
  @Input() iconClass = 'bi-pencil';
  @Input() iconSVG: string | undefined = undefined;
  @Input() buttonText = $localize`:@@InforamtionCard.Button:Ir`;
  @Input() hideButtons = false;
  @Output() buttonClick = new EventEmitter<string>();

  poblation = '';
  municipalities: MunicipalityManagement[] = [];

  constructor(
    private router: Router,
    private municipalitiesService: MunicipalitiesService
    ) {}
    
    ngOnInit() {
      if (this.showPoblation) {
        this.municipalitiesService.getMunicipalitiesManagement().subscribe((response) => {
          this.municipalities = response.municipalities;
        });
      }
  }

  onButtonClick() {
    if (this.showPoblation) {
      const municipality = this.municipalities.find((municipality) => municipality.municipality.municipalityName === this.poblation);
      if (municipality?.municipality.url) {
        window.location.href = municipality.municipality.url;
        return;
      }
    }
    if (this.urlAction) {
      this.router.navigate([this.urlAction]);
      return;
    }
    this.buttonClick.emit(this.poblation);
  }
}
